import React from 'react';

import PropTypes from 'prop-types';

import omegaImage from './omega.png';

const imageStyles = { borderRadius: '50%', objectFit: 'cover' };

const OmegaIcon = ({ size = 64 }) => (
  <img alt="Omega AI" height={size} src={omegaImage} style={imageStyles} width={size} />
);

OmegaIcon.propTypes = {
  size: PropTypes.number,
};

export default OmegaIcon;
